export const inReviewQuestions = {
  inReview: {
    note1: 'applicationForm.IN_REVIEW.note1',
    note2: 'applicationForm.IN_REVIEW.note2',
  },
};
